import type { ReactNode } from 'react'

import { Typography } from '@/src/elements/text/Typography'
import { COMMUNITY_LIFETIME } from '@/src/features/community/models/community.constants'
import type { TDateArg } from '@/src/general/primitives/dates/date.types'
import { formatCalendar } from '@/src/general/primitives/dates/dayjs'
import { capitalizeFirstLetter } from '@/src/general/primitives/strings/capitalize'
import { useTranslate } from '@/src/lang/useTranslate'

type TPublicationDateLabelProps = {
  lifetime: COMMUNITY_LIFETIME
  rank: number
  effectivePublicationDate: TDateArg
}

/**
 * Label displayed above the publication title:
 * - CDI (everlasting community) → the publication date ("Aujourd'hui", "Hier", "24 juin").
 * - Parcours (retreat/novena) → the day number ("Jour X"), based on the publication rank.
 */
export const PublicationDateLabel = ({
  lifetime,
  rank,
  effectivePublicationDate,
}: TPublicationDateLabelProps): ReactNode => {
  const { t } = useTranslate()

  const label =
    lifetime === COMMUNITY_LIFETIME.EVERLASTING
      ? capitalizeFirstLetter(formatCalendar(effectivePublicationDate, t))
      : t('publication.day', { day: rank })

  return (
    <Typography colors="primary" bold>
      {label}
    </Typography>
  )
}
